import { useState } from "react"
import { fetchApi} from "../../tools"

export const useCities = (url, headers, value) => {
    const [cities, setCities] = useState([])
    const handleCity = async (cityId, setFieldValue) => {
        setFieldValue(value, cityId)
        
        try {
            const res = await fetchApi({
                url: url + '/utils/busquedas',
                headers,
                content: {
                    opcion: "MUNICIPIOS_INS",
                    CodDepto: cityId
                }
            })
            setCities(res)
        } catch (err) {
            console.log(err)
        }
    }

    return [cities, handleCity]
}